import { Injectable, inject } from "@angular/core";
import { Database, listVal, objectVal, ref } from "@angular/fire/database";
import { Auth, User, user } from "@angular/fire/auth";
import { firstValueFrom, map, of, switchMap } from "rxjs";
import { iUsuario } from "./usuario.interface";
import { Store } from "@ngrx/store";
import { AppState } from "../app.state";
import { cargaUsuario } from "../states/usuario/actions";
import { setContador } from "../states/despacho/actions";

@Injectable({
  providedIn: "root",
})
export class UsuarioService {
  public readonly store: Store<AppState> = inject(Store);
  private database: Database = inject(Database);
  private auth: Auth = inject(Auth);
  private user$ = user(this.auth);

  getUsuario() {
    return this.user$.pipe(
      switchMap((aUser) =>
        !aUser
          ? of(null)
          : objectVal(ref(this.database, "usuarios/" + aUser?.uid)).pipe(
              switchMap((userData: any) => {
                const user = userData;
                return of({ ...user, uid: aUser?.uid });
              })
            )
      )
    );
  }

  setUsuario(oUsuario: iUsuario) {
    this.store.dispatch(cargaUsuario({ oUsuario }));
    this.store.dispatch(setContador());
  }

  getTemasLectura() {
    return this.getUsuario().pipe(
      map((user: any) => {
        let leer: string[] = [];
        for (let tema in user?.temas) {
          if (
            user?.temas[tema].permiso == 1 ||
            user?.temas[tema].permiso == 3
          ) {
            leer.push(tema);
          }
        }
        return leer;
      })
    );
  }

  getUsuarios() {
    const refCatalogo = ref(this.database, `usuarios`);
    return listVal(refCatalogo, { keyField: "id" }).pipe(
      map((users: any) => {
        users.map((item: any) => {
          item.temas_permiso = Object.keys(item.temas);
          return item;
        });
        return users;
      })
    );
  }
}
